import React, {
  useState,
  useCallback,
  useContext,
  useEffect,
  useMemo,
  useRef,
} from "react";
import { Calendar, Views, momentLocalizer } from "react-big-calendar";
import "react-big-calendar/lib/css/react-big-calendar.css";
import "react-datepicker/dist/react-datepicker.css";
import moment from "moment";
import "moment-timezone";
import { ChevronLeft, ChevronRight, User, Users } from "lucide-react";
import VideoCallIcon from "@mui/icons-material/VideoCall";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import "./CalendarScheduler.css";
import { Toast } from "../../Common/Toast-Snackbar/ToastSnackbar";
import Button from "../Button/Button.js";
import calendarIcon from "../../Assets/Images/calendarIcon.png";
import darkCalendarIcon from "../../Assets/Images/calendar-dark-Icon.png";
import { DynamicContext } from "../../Context/DynamicContext.js";
import Textfield from "../../Common/Textfield/Textfield.js";
// import TimezoneSelector from "./TimezoneSelector.js";
import SidePopup from "../../Common/SidePopup/SidePopup.js";
import candidateIcon from "../../Assets/Images/candidate-schedule-icon.png";
import emailIcon from "../../Assets/Images/email-schedule-icon.png";
import contactNoIcon from "../../Assets/Images/phone-schedule-icon.png";
import jobIcon from "../../Assets/Images/job-schedule-icon.png";
import interviewPersonIcon from "../../Assets/Images/interview-person-schedule-icon.png";
import dateIcon from "../../Assets/Images/calendar-schedule-icon.png";
import linkIcon from "../../Assets/Images/link-schedule-icon.png";
import rescheduleIcon from "../../Assets/Images/reschedule-interview-icon.svg";
import cancelScheduleIcon from "../../Assets/Images/cancel-interview-icon.png";
import ContentDialog from "../Content-Dialog/ContentDialog.js";
import {
  applyEllipsis,
  formatInterviewerName,
} from "../Common-Function/CommonFunctions.js";
import dashboardClock from "../../Assets/Images/dashboardClock.png";
import darkDashboardClock from "../../Assets/Images/dashboard-dark-Clock.png";
import {
  VYLABS_BASE_URL,
  GET_INTERVIEWS_BY_ID,
  DELETE_INTERVIEW,
  UPDATE_INTERVIEW,
  GET_INTERVIEW_BY_TIME_RANGE,
  INTERVIEW_EMAIL_PREVIEW,
  INTERVIEW_PANEL_FEEDBACK,
  INTERVIEW_PANEL_SET,
  GET_CANDIDATE_BY_ID,
  GET_JOB_DETAILS_BY_ID,
  GET_CLIENT_DETAILS,
  GET_VENDOR_DETAILS_BY_ID,
} from "../../helper/url_helper";
import CandidateDetailsContainer from "../Candidate-Details-Container/CandidateDetailsContainer.js";
import JobsDetailsContainer from "../Jobs-Details-Container/JobsDetailsContainer.js";
import { get, deleteRequest, put, post } from "../../helper/Api_helper";
import Accordion from "../Accordion/Accordion.js";
import { useFormik } from "formik";
import * as Yup from "yup";
import { CustomDatePickerModal } from "../Date-Picker/DatePicker";
import CustomTimePicker from "../Time-Picker/TimePicker";
import { convertUTCTimeToUserTimezone } from "../Time-Zone-Utils/timezoneUtils.js";
import EmailPreviewPopup from "../EmailPreviewPopup/EmailPreviewPopup";
import { filterPayload } from "../Common-Function/CommonFunctions.js";
import { StandardPopup } from "../PopupStyles/PopupComponent.js";
import ReactDOM from "react-dom";
import CustomTooltip from "../../Common/Tooltip/Tooltip.js";
import SelectedStarIcon from "../../Assets/Images/SelectedStar.svg";
import NotSelectedStarIcon from "../../Assets/Images/NotSelectedStar.svg";
import TextArea from "../TextArea/TextArea.js";
import CandidateInterviewPanel from "./CandidateInterviewPanel.js";
import MonthFilter from "../Month-Filter/MonthFilter.js";

const MyCalendar = ({ initialEvents, candidate }) => {
  const [events, setEvents] = useState(
    initialEvents?.map((event) => ({
      ...event,
      id: crypto.randomUUID(),
      start: new Date(event.start),
      end: new Date(event.end),
    })) || [],
  );
  const {
    isDarkMode,
    userTimezone,
    isMonthlyEmailLimitReached,
    getMonthlyEmailTooltip,
    isHiringTeamTenant,
    userDetails,
    setIsFromCandidateRecommendedJobs,
  } = useContext(DynamicContext);
  const [currentTimezone, setCurrentTimezone] = useState("");
  const [selectedDate, setSelectedDate] = useState(new Date());
  const [currentView, setCurrentView] = useState(Views.WEEK);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [isDatePickerOpen, setIsDatePickerOpen] = useState(false);
  const [activeDatePicker, setActiveDatePicker] = useState(null);
  const [showCandidateDetails, setShowCandidateDetails] = useState(false);
  const [isFeedbackPopupOpen, setIsFeedbackPopupOpen] = useState(false);
  const [feedbackMember, setFeedbackMember] = useState(null);
  const [hoveredFeedbackScore, setHoveredFeedbackScore] = useState(0);
  const [selectedCandidate, setSelectedCandidate] = useState(null);
  const [isCandidateModalOpen, setIsCandidateModalOpen] = useState(false);
  const [viewingCandidate, setViewingCandidate] = useState(null);
  const [candidateActiveTab, setCandidateActiveTab] = useState(0);
  const [assignedVendor, setAssignedVendor] = useState(null);

  const [jobsSideContainerOpen, setJobsSideContainerOpen] = useState(false);
  const [selectedJob, setSelectedJob] = useState(null);
  const [jobActiveTab, setJobActiveTab] = useState("Job Details");
  const [assignedCount, setAssignedCount] = useState(0);
  const [getInterviewID, setGetInterviewID] = useState(null);
  const toolbarDateRef = useRef(null);
  const rescheduleDateRef = useRef(null);
  const [pickerPosition, setPickerPosition] = useState({
    top: null,
    left: null,
  });
  const [isEmailPreviewOpen, setIsEmailPreviewOpen] = useState(false);
  const [previewData, setPreviewData] = useState({
    body: "",
    subject: "",
    isLoading: false,
  });
  const [newEvent, setNewEvent] = useState({
    start: null,
    end: null,
    candidateName: candidate.candidate.name,
    position: candidate.candidate.role,
    background: "linear-gradient(rgb(158 153 235) 0%, rgb(66, 56, 224) 100%)",
    textColor: "#ffffff",
  });
  const [isDragging, setIsDragging] = useState(false);
  const [isEditingInterview, setIsEditingInterview] = useState(false);
  const [isSubmittingUpdate, setIsSubmittingUpdate] = useState(false);
  const [storePanelData, setStorePanelData] = useState([]);
  const [panelMemberIds, setPanelMemberIds] = useState([]);

  const localizer = useMemo(() => {
    moment.tz.setDefault(currentTimezone);
    return momentLocalizer(moment);
  }, [currentTimezone]);
  useEffect(() => {
    if (
      userTimezone &&
      typeof userTimezone === "string" &&
      userTimezone.trim() !== ""
    ) {
      setCurrentTimezone(userTimezone.trim());
    }
  }, [userTimezone]);

  const validationSchema = Yup.object().shape({
    interviewDate: Yup.date()
      .required("Interview date is required")
      .typeError("Please select a valid date")
      .min(moment().startOf("day").toDate(), "Date cannot be in the past"),
    interviewPerson: Yup.string().required("Interview person is required"),
    startTime: Yup.string().required("Start time is required"),
    endTime: Yup.string()
      .required("End time is required")
      .test(
        "is-after-start",
        "End time must be after start time",
        function (endTime) {
          const { interviewDate, startTime } = this.parent;
          if (!interviewDate || !startTime || !endTime) return true;

          const start = new Date(
            `${moment(interviewDate).format("YYYY-MM-DD")} ${startTime}`,
          );
          const end = new Date(
            `${moment(interviewDate).format("YYYY-MM-DD")} ${endTime}`,
          );
          return end > start;
        },
      ),
    interviewType: Yup.string()
      .oneOf(["online", "offline"], "Please select interview type")
      .required("Interview type is required"),
    meetingLink: Yup.string().when(["interviewType"], {
      is: (interviewType) => interviewType === "online",
      then: (schema) =>
        schema.required("Meeting link is required for online interviews"),
      otherwise: (schema) => schema.notRequired(),
    }),
    address1: Yup.string().when(["interviewType"], {
      is: (interviewType) => interviewType === "offline",
      then: (schema) =>
        schema.required("Address is required for in-person interviews"),
      otherwise: (schema) => schema.notRequired(),
    }),
    country: Yup.string().when(["interviewType"], {
      is: (interviewType) => interviewType === "offline",
      then: (schema) =>
        schema.required("Country is required for in-person interviews"),
      otherwise: (schema) => schema.notRequired(),
    }),
    state: Yup.string().when(["interviewType"], {
      is: (interviewType) => interviewType === "offline",
      then: (schema) =>
        schema.required("State is required for in-person interviews"),
      otherwise: (schema) => schema.notRequired(),
    }),
    city: Yup.string().when(["interviewType"], {
      is: (interviewType) => interviewType === "offline",
      then: (schema) =>
        schema.required("City is required for in-person interviews"),
      otherwise: (schema) => schema.notRequired(),
    }),
    zipcode: Yup.string().when(["interviewType"], {
      is: (interviewType) => interviewType === "offline",
      then: (schema) =>
        schema.required("Zipcode is required for in-person interviews"),
      otherwise: (schema) => schema.notRequired(),
    }),
  });

  const feedbackFormik = useFormik({
    initialValues: {
      score: 4,
      hiringRecommendation: "Hire",
      feedbackNotes: "",
    },
    onSubmit: async () => {
      await createInterviewPanelFeedback();
    },
  });

  useEffect(() => {
    if (isFeedbackPopupOpen) {
      feedbackFormik.resetForm({
        values: {
          score: feedbackMember?.rating ?? 4,
          hiringRecommendation: feedbackMember?.hiring_recommendation || "Hire",
          feedbackNotes: feedbackMember?.notes ?? "",
        },
      });
      setHoveredFeedbackScore(0);
    }
  }, [isFeedbackPopupOpen, feedbackMember]);

  const scheduleformik = useFormik({
    initialValues: {
      candidateName: candidate.candidate.name || "",
      interviewPerson: "",
      companyName: "",
      interviewDate: null,
      startTime: "",
      endTime: "",
      timezone: "UTC",
      address1: "",
      address2: "",
      country: "",
      state: "",
      city: "",
      zipcode: "",
      meetingLink: "",
      interviewType: "online",
    },
    validationSchema: validationSchema,
    onSubmit: (values) => {
      if (!values.interviewDate) {
        scheduleformik.setFieldError(
          "interviewDate",
          "Interview date is required",
        );
        return;
      }
      const startDateTime = new Date(
        `${moment(values.interviewDate).format("YYYY-MM-DD")} ${
          values.startTime
        }`,
      );
      const endDateTime = new Date(
        `${moment(values.interviewDate).format("YYYY-MM-DD")} ${values.endTime}`,
      );

      const eventToAdd = {
        id: crypto.randomUUID(),
        start: startDateTime,
        end: endDateTime,
        title: `${values.candidateName} - ${values.appliedJob}`,
        candidateName: values.candidateName,
        position: values.appliedJob,
        email: values.email,
        contactNo: values.contactNo,
        interviewPerson: values.interviewPerson,
        startTime: moment(values.start).format("h:mm A"),
        endTime: moment(values.end).format("h:mm A"),
        date: moment(values.start).format("MMMM D, YYYY"),
        meetingLink: values.meetingLink,
        background:
          "linear-gradient(rgb(158 153 235) 0%, rgb(66, 56, 224) 100%)",
        textColor: "#ffffff",
      };

      setEvents([...events, eventToAdd]);
    },
  });

  const calendarDateFormat = (date, time, interviewTimezone) => {
    return convertUTCTimeToUserTimezone(
      date,
      time,
      interviewTimezone,
      // currentTimezone,
    );
  };

  const canAccessPreview = () => {
    const values = scheduleformik.values;
    const hasRequiredBase =
      values.interviewPerson?.trim() &&
      values.interviewDate &&
      values.startTime &&
      values.endTime;

    const hasMeetingInfo =
      values.interviewType === "online"
        ? values.meetingLink?.trim()
        : values.address1?.trim();

    return hasRequiredBase && hasMeetingInfo;
  };

  const fetchEmailPreview = async () => {
    const values = scheduleformik.values;
    const applicationID = selectedCandidate?.applicationId;

    if (!applicationID) {
      Toast("error", "No valid application ID found for this candidate");
      return;
    }
    setPreviewData((prev) => ({ ...prev, isLoading: true }));
    try {
      const rawPayload = {
        address: values.address1,
        applicationID: applicationID,
        city: values.city,
        companyName: values.companyName,
        country: values.country,
        date: values.interviewDate
          ? `${values.interviewDate.getFullYear()}-${String(
              values.interviewDate.getMonth() + 1,
            ).padStart(2, "0")}-${String(
              values.interviewDate.getDate(),
            ).padStart(2, "0")}`
          : null,
        interviewerName: values.interviewPerson,
        meetingLink: values.meetingLink,
        state: values.state,
        timeEnd: values.endTime,
        timeStart: values.startTime,
        timezone: values.timezone,
        zipCode: values.zipcode?.toString() || "",
      };
      const payload = filterPayload(rawPayload);
      const response = await post(
        VYLABS_BASE_URL,
        INTERVIEW_EMAIL_PREVIEW,
        payload,
      );

      if (response) {
        setPreviewData({
          body: response.body || "",
          subject: response.subject || "Interview Confirmation",
          isLoading: false,
        });
        setIsEmailPreviewOpen(true);
      }
    } catch (error) {
      console.error("Error fetching email preview:", error);
      Toast("error", error.message || "Failed to load email preview");
      setPreviewData((prev) => ({ ...prev, isLoading: false }));
    }
  };

  const handleCloseDeleteModal = () => {
    setShowDeleteModal(false);
  };

  const handleOpenDeleteModal = (event) => {
    setShowDeleteModal(true);
    setShowCandidateDetails(false);
  };

  const EventComponent = ({ event, onClick }) => {
    const eventTimezone = event.timezone;
    const startTime = moment(event.start).format("h:mm A");
    const endTime = moment(event.end).format("h:mm A");

    return (
      <div className="interview-event-container" onClick={onClick}>
        <div className="event-header">
          <div className="event-position">{event.position}</div>
          <div className="event-time">
            {startTime} - {endTime} ({eventTimezone})
          </div>
        </div>
        <div className="event-candidate">
          <User size={14} className="event-icon" />
          <span>{event.candidate_name}</span>
        </div>
        <div
          className="event-indicator"
          style={{
            width: "40%",
            height: "3px",
            background: "rgba(255,255,255,0.3)",
            borderRadius: "2px",
            marginTop: "6px",
          }}
        ></div>
      </div>
    );
  };

  const handleCloseCandidateDetails = () => {
    setShowCandidateDetails(false);
    setSelectedCandidate(null);
    setIsEditingInterview(false);
    setPanelMemberIds([]);
    setIsEmailPreviewOpen(false);
    setPreviewData({ body: "", subject: "", isLoading: false });
    setIsCandidateModalOpen(false);
    setViewingCandidate(null);
    setJobsSideContainerOpen(false);
    setSelectedJob(null);
  };

  const handleOpenCandidateDetails = async (candidateId) => {
    if (!candidateId) return;
    const initialData = selectedCandidate?.candidateData || {
      id: candidateId,
      name: selectedCandidate?.name,
      email: selectedCandidate?.email,
      phone: selectedCandidate?.contactNo,
    };
    setViewingCandidate(initialData);
    setIsCandidateModalOpen(true);
    setCandidateActiveTab(0);
    try {
      const res = await get(
        VYLABS_BASE_URL,
        `${GET_CANDIDATE_BY_ID}?id=${candidateId}`,
      );
      const candidate = res?.candidate;
      const candidatefiles = res?.files;
      let parsedResumeData = {};
      if (candidate?.parsed_resume && candidate.parsed_resume.trim() !== "") {
        try {
          parsedResumeData = JSON.parse(candidate.parsed_resume);
        } catch (error) {
          console.error("Error parsing resume data:", error);
          parsedResumeData = {};
        }
      }
      const presignedUrl =
        candidatefiles && candidatefiles.length > 0
          ? candidatefiles[0].presigned_url
          : null;

      const updatedCandidate = {
        ...candidate,
        secondaryEmail: candidate?.secondary_email,
        secondaryPhone: candidate?.secondary_phone,
        vendorID: candidate?.vendor_id,
        parsedResumeData,
        files: candidatefiles || null,
        presignedUrl,
        isFileBased: false,
        avatar: res?.profile_img_url,
        preferredSalary: candidate?.preferred_salary,
        lineAddress1: candidate?.line_address_1,
        lineAddress2: candidate?.line_address_2,
        zipCode: candidate?.zip_code,
        designation: candidate?.designation,
        source: candidate?.source,
        industry: candidate?.industry,
        experience: candidate?.years_of_experience,
      };

      if (updatedCandidate.vendorID) {
        try {
          const vendorResponse = await get(
            VYLABS_BASE_URL,
            `${GET_VENDOR_DETAILS_BY_ID}?id=${updatedCandidate.vendorID}`,
          );
          setAssignedVendor(vendorResponse);
          updatedCandidate.vendorDetails = vendorResponse?.vendor || null;
        } catch (err) {
          console.error("Error fetching vendor details:", err);
          updatedCandidate.vendorDetails = null;
        }
      } else {
        updatedCandidate.vendorDetails = null;
      }

      setViewingCandidate(updatedCandidate);
    } catch (error) {
      console.error("Error fetching candidate details:", error);
    }
  };

  const handleCloseCandidateModal = () => {
    setIsCandidateModalOpen(false);
    setViewingCandidate(null);
    setCandidateActiveTab(0);
    setAssignedVendor(null);
  };

  const handleOpenJobsSideContainer = async (jobId) => {
    if (!jobId) return;
    const initialJob = selectedCandidate?.jobData || {
      id: jobId,
      title: selectedCandidate?.position,
    };
    setSelectedJob(initialJob);
    setJobsSideContainerOpen(true);
    setJobActiveTab("Job Details");
    setIsFromCandidateRecommendedJobs?.(false);
    try {
      const jobRes = await get(
        VYLABS_BASE_URL,
        `${GET_JOB_DETAILS_BY_ID}?id=${jobId}`,
      );
      let detailedJob = jobRes?.job || initialJob;
      if (detailedJob?.client_id && !detailedJob?.client?.contact_person) {
        try {
          const clientRes = await get(
            VYLABS_BASE_URL,
            `${GET_CLIENT_DETAILS}/?id=${detailedJob.client_id}`,
          );
          if (clientRes?.client) {
            detailedJob.client = clientRes.client;
          }
        } catch (err) {
          console.warn("Could not fetch client details:", err);
        }
      }
      setSelectedJob(detailedJob);
    } catch (err) {
      console.error("Error fetching job details:", err);
    }
  };

  const handleCloseJobsSideContainer = () => {
    setJobsSideContainerOpen(false);
    setSelectedJob(null);
    setJobActiveTab("Job Details");
    setIsFromCandidateRecommendedJobs?.(false);
  };

  const CustomToolbar = ({ label }) => {
    return (
      <div className="toolbar">
        {/* <div className="toolbar-left">
          <TimezoneSelector
            selectedTimezone={currentTimezone}
            onTimezoneChange={handleTimezoneChange}
            selectStyle={{ width: "240px", marginBottom: "10px" }}
          />
        </div> */}
        <div
          ref={toolbarDateRef}
          className="calendar-date-wrapper"
          onClick={() => {
            const rect = toolbarDateRef.current.getBoundingClientRect();
            setPickerPosition({
              top: rect.bottom + 6,
              left: rect.left,
            });
            requestAnimationFrame(() => {
              setActiveDatePicker("toolbar");
              setIsDatePickerOpen(true);
            });
          }}
        >
          <img
            alt=""
            src={isDarkMode ? darkCalendarIcon : calendarIcon}
            style={{ width: "22px", marginRight: "10px" }}
          />
          <div className="calender-toolbar-label">{label}</div>
        </div>
        <div className="view-and-button">
          <ViewSelector />
        </div>
        <div className="calendar-navigation">
          <button
            className="navigate-btn previous-btn"
            onClick={() => navigateByView("prev")}
            title="Previous"
          >
            <ChevronLeft size={18} strokeWidth={2.5} />
          </button>
          <button onClick={() => navigateByView("next")} title="Next">
            <ChevronRight size={18} strokeWidth={2.5} />
          </button>
        </div>
      </div>
    );
  };
  // const handleTimezoneChange = (newTimezone) => {
  //   setCurrentTimezone(newTimezone);
  // };
  const fetchScheduledInterviews = async (startDate, endDate) => {
    try {
      const response = await get(VYLABS_BASE_URL, GET_INTERVIEW_BY_TIME_RANGE, {
        params: {
          start_date: moment(startDate).format("YYYY-MM-DD"),
          end_date: moment(endDate).format("YYYY-MM-DD"),
          limit: 30,
          offset: 0,
        },
      });
      const interviews = response.interviews || [];
      const calendarEvents = interviews.map((interview) => ({
        id: interview.id,
        application_id: interview.application_id,
        date: interview.date,
        time_start: interview.time_start,
        time_end: interview.time_end,
        meeting_link: interview.meeting_link || "",
        address: interview.address || "",
        address2: interview.address2 || "",
        city: interview.city || "",
        country: interview.country || "",
        state: interview.state || "",
        zip_code: interview.zip_code || "",
        start: calendarDateFormat(
          interview.date,
          interview.time_start,
          interview.timezone,
        ),
        end: calendarDateFormat(
          interview.date,
          interview.time_end,
          interview.timezone,
        ),
        title: `${interview.interviewer_name} - Interview`,
        candidate_name: interview.candidate_name || "",
        interviewer_name: interview.interviewer_name || "",
        company_name: interview.company_name || "",
        position: "",
        timezone: interview.timezone,
      }));

      setEvents(calendarEvents);
    } catch (error) {
      console.error("Failed to fetch interviews:", error);
    }
  };

  useEffect(() => {
    const getDateRange = () => {
      let startDate, endDate;
      switch (currentView) {
        case Views.DAY:
          startDate = selectedDate;
          endDate = selectedDate;
          break;
        case Views.WEEK:
          startDate = moment(selectedDate).startOf("week").toDate();
          endDate = moment(selectedDate).endOf("week").toDate();
          break;
        case Views.MONTH:
          startDate = moment(selectedDate).startOf("month").toDate();
          endDate = moment(selectedDate).endOf("month").toDate();
          break;
        default:
          startDate = selectedDate;
          endDate = selectedDate;
      }
      return { startDate, endDate };
    };

    const { startDate, endDate } = getDateRange();
    fetchScheduledInterviews(startDate, endDate);
  }, []);

  useEffect(() => {
    const getDateRange = () => {
      let startDate, endDate;
      switch (currentView) {
        case Views.DAY:
          startDate = selectedDate;
          endDate = selectedDate;
          break;
        case Views.WEEK:
          startDate = moment(selectedDate).startOf("week").toDate();
          endDate = moment(selectedDate).endOf("week").toDate();
          break;
        case Views.MONTH:
          startDate = moment(selectedDate).startOf("month").toDate();
          endDate = moment(selectedDate).endOf("month").toDate();
          break;
        default:
          startDate = selectedDate;
          endDate = selectedDate;
      }
      return { startDate, endDate };
    };

    const { startDate, endDate } = getDateRange();
    fetchScheduledInterviews(startDate, endDate);
  }, [selectedDate, currentView, currentTimezone]);

  const fetchcandidatebyInterviewId = async (interviewId) => {
    setGetInterviewID(interviewId);
    try {
      const response = await get(VYLABS_BASE_URL, GET_INTERVIEWS_BY_ID, {
        params: { id: interviewId },
      });
      const { interviews = [], candidate, job, application } = response;
      const calendarEvents =
        interviews && interviews.length > 0
          ? interviews.map((interview) => ({
              id: interview.id,
              application_id: interview.application_id,
              title: `${interview.candidateName} - Interview`,
              position: job?.title || "",
              interviewPerson: interview.interviewer_name || "",
              end: calendarDateFormat(
                interview.date,
                interview.time_end,
                interview.timezone,
              ),
              start: calendarDateFormat(
                interview.date,
                interview.time_start,
                interview.timezone,
              ),
              timezone: interview.timezone,
            }))
          : [];

      const { interview } = response;
      setStorePanelData(interview?.panel || []);
      return {
        application,
        candidate,
        job,
        interviews,
        calendarEvents,
        interview,
      };
    } catch (error) {
      console.error("Failed to fetch interviews by interview ID:", error);
      return null;
    }
  };

  const handleInterviewClick = async (interview) => {
    const interviewId = interview?.id;
    if (!interviewId) return;

    const data = await fetchcandidatebyInterviewId(interviewId);
    if (data && data.candidate) {
      const fullInterview =
        data.interviews?.find((i) => i.id === interviewId) || interview;
      const eventTimezone = interview.timezone;
      const startTimeFormatted = moment(interview.start)
        .tz(eventTimezone)
        .format("HH:mm");
      const endTimeFormatted = moment(interview.end)
        .tz(eventTimezone)
        .format("HH:mm");

      setSelectedCandidate({
        ...data.candidate,
        email: data.candidate.email || "",
        contactNo: data.candidate.phone || "",
        position: data.job?.title || "",
        interviewPerson: interview.interviewer_name || "",
        companyName: interview.company_name || "",
        startTime: moment(interview.start).tz(eventTimezone).format("h:mm A"),
        endTime: moment(interview.end).tz(eventTimezone).format("h:mm A"),
        date: moment(interview.start).tz(eventTimezone).format("MMMM D, YYYY"),
        meetingLink: interview.meeting_link || "",
        interviewType: interview.meeting_link ? "online" : "offline",
        address1: interview.address || "",
        address2: interview.address2 || "",
        country: interview.country || "",
        state: interview.state || "",
        city: interview.city || "",
        zipcode: interview.zip_code || "",
        timezone: eventTimezone,
        applicationId: interview.application_id,
        candidateId:
          data.candidate?.id ||
          data.interview?.candidate_id ||
          interview?.candidate_id,
        jobId: data.job?.id || fullInterview?.job_id || interview?.job_id,
        jobData: data.job,
        candidateData: data.candidate,
      });

      scheduleformik.setValues({
        candidateName: data.candidate.name || "",
        email: data.candidate.email || "",
        contactNo: data.candidate.phone || "",
        interviewPerson: interview.interviewer_name || "",
        companyName: interview.company_name || "",
        interviewDate: moment(interview.start).toDate(),
        startTime: startTimeFormatted,
        endTime: endTimeFormatted,
        timezone: interview.timezone,
        address1: interview.address || "",
        address2: interview.address2 || "",
        country: interview.country || "",
        state: interview.state || "",
        city: interview.city || "",
        zipcode: interview.zip_code || "",
        meetingLink: interview.meeting_link || "",
        interviewType: interview.meeting_link ? "online" : "offline",
      });

      setStorePanelData(data?.interview?.panel || []);
      setGetInterviewID(interviewId);
      setShowCandidateDetails(true);
    }
  };

  const handleDeleteEvent = async () => {
    try {
      await deleteRequest(VYLABS_BASE_URL, DELETE_INTERVIEW, {
        id: getInterviewID,
      });
      const getDateRange = () => {
        let startDate, endDate;
        switch (currentView) {
          case Views.DAY:
            startDate = selectedDate;
            endDate = selectedDate;
            break;
          case Views.WEEK:
            startDate = moment(selectedDate).startOf("week").toDate();
            endDate = moment(selectedDate).endOf("week").toDate();
            break;
          case Views.MONTH:
            startDate = moment(selectedDate).startOf("month").toDate();
            endDate = moment(selectedDate).endOf("month").toDate();
            break;
          default:
            startDate = selectedDate;
            endDate = selectedDate;
        }
        return { startDate, endDate };
      };

      const { startDate, endDate } = getDateRange();
      await fetchScheduledInterviews(startDate, endDate);

      Toast("success", "Event deleted successfully");
    } catch (error) {
      console.error("Error deleting event:", error);
    } finally {
      setShowDeleteModal(false);
      setShowCandidateDetails(false);
    }
  };

  const handleSelectSlot = ({ start, end }) => {
    if (!isDragging) {
      setNewEvent({
        ...newEvent,
        start: new Date(start),
        end: new Date(end),
      });
    }
  };

  const navigateByView = (direction) => {
    const newDate = new Date(selectedDate);

    switch (currentView) {
      case Views.DAY:
        const dayOffset = direction === "prev" ? -1 : 1;
        newDate.setDate(newDate.getDate() + dayOffset);
        break;
      case Views.WEEK:
        const weekOffset = direction === "prev" ? -7 : 7;
        newDate.setDate(newDate.getDate() + weekOffset);
        break;
      case Views.MONTH:
        if (direction === "prev") {
          newDate.setMonth(newDate.getMonth() - 1);
        } else {
          newDate.setMonth(newDate.getMonth() + 1);
        }
        break;
      default:
        break;
    }

    setSelectedDate(newDate);
    let startDate, endDate;
    switch (currentView) {
      case Views.DAY:
        startDate = newDate;
        endDate = newDate;
        break;
      case Views.WEEK:
        startDate = moment(newDate).startOf("week").toDate();
        endDate = moment(newDate).endOf("week").toDate();
        break;
      case Views.MONTH:
        startDate = moment(newDate).startOf("month").toDate();
        endDate = moment(newDate).endOf("month").toDate();
        break;
      default:
        startDate = newDate;
        endDate = newDate;
    }
  };

  const handleViewChange = (view) => {
    setCurrentView(view);
  };

  const moveEvent = useCallback(({ event, start, end }) => {
    setEvents((prevEvents) => {
      const idx = prevEvents.indexOf(event);
      const updatedEvent = { ...event, start, end };
      const nextEvents = [...prevEvents];
      nextEvents.splice(idx, 1, updatedEvent);
      return nextEvents;
    });
  }, []);

  const resizeEvent = useCallback(({ event, start, end }) => {
    setEvents((prevEvents) => {
      const idx = prevEvents.indexOf(event);
      const updatedEvent = { ...event, start, end };
      const nextEvents = [...prevEvents];
      nextEvents.splice(idx, 1, updatedEvent);
      return nextEvents;
    });
  }, []);

  const onDragStart = useCallback(() => {
    setIsDragging(true);
  }, []);

  const onDragEnd = useCallback(() => {
    setTimeout(() => setIsDragging(false), 100);
  }, []);

  const getViewName = (view) => {
    switch (view) {
      case Views.DAY:
        return "Day";
      case Views.WEEK:
        return "Week";
      case Views.MONTH:
        return "Month";
      default:
        return view;
    }
  };

  const ViewSelector = () => (
    <div className="view-selector">
      {[Views.DAY, Views.WEEK, Views.MONTH].map((view) => (
        <button
          key={view}
          onClick={() => handleViewChange(view)}
          className={currentView === view ? "active" : ""}
        >
          {getViewName(view)}
        </button>
      ))}
    </div>
  );

  // const TimezoneDisplay = () => {
  //   const offset = moment().tz(currentTimezone).format("Z");
  //   const timezoneAbbr =
  //     moment.tz.zone(currentTimezone)?.abbr(new Date().getTime()) ||
  //     currentTimezone;
  //   return (
  //     <>
  //       <div style={{ fontSize: "12px", color: "var(--header__color)" }}>
  //         {timezoneAbbr} {offset}
  //       </div>
  //     </>
  //   );
  // };

  const TimeGutterHeader = () => {
    return (
      <div style={{ height: "100%", padding: "8px" }}>
        {/* <TimezoneDisplay /> */}
      </div>
    );
  };
  // const eventsWithTimezone = events.map((event) => {
  //   const startInTz = moment.utc(event.start).tz(currentTimezone);
  //   const endInTz = moment.utc(event.end).tz(currentTimezone);

  //   return {
  //     ...event,
  //     start: startInTz.toDate(),
  //     end: endInTz.toDate(),
  //     originalStart: event.start,
  //     originalEnd: event.end,
  //   };
  // });
  const CustomEventWrapper = ({ children, event }) => {
    const overlappingEvents = events.filter(
      (ev) =>
        ev.id !== event.id &&
        ((ev.start < event.end && ev.end > event.start) ||
          (event.start < ev.end && event.end > ev.start)),
    ).length;

    return React.cloneElement(React.Children.only(children), {
      style: {
        ...children.props.style,
        zIndex: 100 + overlappingEvents,
        width:
          overlappingEvents > 0
            ? `calc(100% - ${overlappingEvents * 5}px)`
            : "100%",
        marginLeft: overlappingEvents * 5,
      },
    });
  };

  const MonthEventComponent = ({ event }) => (
    <div className="month-interview-event">
      <div className="month-event-time">
        {moment(event.start).format("h:mm")}
      </div>
      <div className="month-event-name">
        {event.candidateName || "Interview"}
      </div>
    </div>
  );

  const updateInterview = async () => {
    const values = scheduleformik.values;
    const rawPayload = {
      id: getInterviewID,
      date: values.interviewDate
        ? `${values.interviewDate.getFullYear()}-${String(
            values.interviewDate.getMonth() + 1,
          ).padStart(2, "0")}-${String(values.interviewDate.getDate()).padStart(
            2,
            "0",
          )}`
        : null,
      timeStart: values.startTime,
      timeEnd: values.endTime,
      interviewerName: values.interviewPerson,
      companyName: values.companyName,
      timezone: values.timezone,
      address: values.address1,
      address2: values.address2,
      city: values.city,
      country: values.country,
      state: values.state,
      zipCode: values.zipcode?.toString() || "",
      meetingLink: values.meetingLink,
      applicationID: selectedCandidate?.applicationId,
    };
    const payload = {
      ...filterPayload(rawPayload),
      ...(values.interviewType === "online"
        ? {
            address: "",
            address2: "",
            country: "",
            state: "",
            city: "",
            zipCode: "",
          }
        : { meetingLink: "", address2: values.address2 || "" }),
    };
    await put(VYLABS_BASE_URL, UPDATE_INTERVIEW, payload);
  };

  const handleUpdateInterview = async () => {
    scheduleformik.setTouched({
      interviewDate: true,
      startTime: true,
      endTime: true,
      interviewPerson: true,
      interviewType: true,
      meetingLink: true,
      address1: true,
      country: true,
      state: true,
      city: true,
      zipcode: true,
    });
    await scheduleformik.validateForm();
    if (
      scheduleformik.errors.interviewDate ||
      scheduleformik.errors.startTime ||
      scheduleformik.errors.endTime ||
      scheduleformik.errors.interviewPerson
    ) {
      return;
    }
    setIsSubmittingUpdate(true);
    try {
      await updateInterview();
      Toast("success", "Interview updated successfully");

      try {
        await put(VYLABS_BASE_URL, INTERVIEW_PANEL_SET, {
          interview_id: getInterviewID,
          members: panelMemberIds.map((id) => ({ user_id: id })),
        });
      } catch (panelError) {
        console.error(
          "Error setting interview panel:",
          panelError.response?.data || panelError.message,
        );
        Toast(
          "error",
          panelError.response?.data?.message ||
            "Interview updated, but failed to assign the interview panel",
        );
      }

      setIsEditingInterview(false);
      setShowCandidateDetails(false);
      const getDateRange = () => {
        let startDate, endDate;
        switch (currentView) {
          case Views.DAY:
            startDate = selectedDate;
            endDate = selectedDate;
            break;
          case Views.WEEK:
            startDate = moment(selectedDate).startOf("week").toDate();
            endDate = moment(selectedDate).endOf("week").toDate();
            break;
          case Views.MONTH:
            startDate = moment(selectedDate).startOf("month").toDate();
            endDate = moment(selectedDate).endOf("month").toDate();
            break;
          default:
            startDate = selectedDate;
            endDate = selectedDate;
        }
        return { startDate, endDate };
      };
      const { startDate, endDate } = getDateRange();
      await fetchScheduledInterviews(startDate, endDate);
    } catch (error) {
      Toast("error", "Failed to update interview");
      console.error(error);
    } finally {
      setIsSubmittingUpdate(false);
    }
  };

  const handleRescheduleClick = () => {
    if (isMonthlyEmailLimitReached) {
      Toast("error", "Monthly email limit reached. Please upgrade your plan.");
      return;
    }

    const existingPanelIds = Array.from(
      new Map(
        (Array.isArray(storePanelData) ? storePanelData : [])
          .map((member) => member?.user_id)
          .filter(
            (userId) =>
              userId !== undefined &&
              userId !== null &&
              String(userId).trim() !== "",
          )
          .map((userId) => [String(userId), userId]),
      ).values(),
    );
    setPanelMemberIds(existingPanelIds);

    if (
      selectedCandidate &&
      selectedCandidate.date &&
      selectedCandidate.startTime &&
      selectedCandidate.endTime
    ) {
      const interviewDate = moment(
        selectedCandidate.date,
        "MMMM D, YYYY",
      ).toDate();
      const startTime = moment(selectedCandidate.startTime, "h:mm A").format(
        "HH:mm",
      );
      const endTime = moment(selectedCandidate.endTime, "h:mm A").format(
        "HH:mm",
      );

      scheduleformik.setValues({
        ...scheduleformik.values,
        interviewDate,
        startTime,
        endTime,
        timezone: selectedCandidate.timezone,
        companyName: selectedCandidate.companyName || "",
      });
    }

    setIsEditingInterview(true);
  };

  const handleBackClick = () => {
    setIsEditingInterview(false);
    scheduleformik.resetForm();
    setIsEmailPreviewOpen(false);
    setPreviewData({ body: "", subject: "", isLoading: false });
  };

  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const createInterviewPanelFeedback = async () => {
    try {
      await put(VYLABS_BASE_URL, INTERVIEW_PANEL_FEEDBACK, {
        interview_id: getInterviewID,
        notes: feedbackFormik.values.feedbackNotes,
        rating: feedbackFormik.values.score,
        hiring_recommendation: feedbackFormik.values.hiringRecommendation,
      });
      await fetchcandidatebyInterviewId(getInterviewID);
      Toast("success", "Feedback submitted successfully!");
      setIsFeedbackPopupOpen(false);
      feedbackFormik.resetForm();
      setFeedbackMember(null);
    } catch (error) {
      console.error("error in createInterviewPanelFeedback", error);
      Toast("error", error.response?.data || "Failed to submit feedback");
    }
  };

  const showInterviewFeedbackButton = storePanelData.find(
    (data) => userDetails.id === data.user_id,
  );

  return (
    <div className="calendar-container">
      <Calendar
        localizer={localizer}
        events={events}
        startAccessor="start"
        endAccessor="end"
        titleAccessor="title"
        onSelectSlot={handleSelectSlot}
        onSelectEvent={handleInterviewClick}
        selectable
        views={[Views.MONTH, Views.WEEK, Views.DAY]}
        date={selectedDate}
        onNavigate={setSelectedDate}
        onView={handleViewChange}
        view={currentView}
        className="react-calendar-container"
        defaultView={Views.DAY}
        draggableAccessor={() => true}
        resizable={false}
        onEventDrop={moveEvent}
        onEventResize={resizeEvent}
        onDragStart={onDragStart}
        onDragEnd={onDragEnd}
        timeslots={4}
        step={15}
        components={{
          event: (props) => (
            <EventComponent
              {...props}
              onClick={() => handleInterviewClick(props.event)}
            />
          ),
          timeGutterHeader: TimeGutterHeader,
          toolbar: CustomToolbar,
          eventWrapper: CustomEventWrapper,
          month: {
            event: MonthEventComponent,
          },
        }}
        eventPropGetter={(event) => {
          return {
            style: {
              background: "linear-gradient(135deg, #6860ee 0%, #4238e0 100%)",
              color: "white",
              borderRadius: "8px",
              boxShadow: "0 2px 6px rgba(0, 0, 0, 0.15)",
              border: "none",
              borderLeft: "4px solid #2b21d3",
            },
          };
        }}
      />
      <SidePopup
        isOpen={showCandidateDetails}
        onClose={handleCloseCandidateDetails}
        title={selectedCandidate?.position}
        titleColor="var(--sidepopup-header-color)"
        headerBackgroundColor="var(--sidepopup-header-background)"
        sidePopupWidth={"47%"}
        sidePopupStyle={{
          boxShadow: "0 0 30px rgba(0, 0, 0, 0.15)",
          borderRadius: "16px 0 0 16px",
        }}
      >
        {selectedCandidate && (
          <div className="candidate-details-popup">
            <div className="candidate-details-outer-container">
              <div className="candidate-details-inner-container">
                <h3 className="schedule-header">Candidate Details</h3>
                <div className="schedule-detail">
                  <div
                    className="candidate-detail"
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        minWidth: 0,
                        flex: 1,
                      }}
                    >
                      <div className="icon-with-header">
                        <img
                          src={candidateIcon}
                          alt="candidateIcon"
                          className="candidate-detail-icon"
                        />
                        <h4>Candidate</h4>
                      </div>
                      <p>{applyEllipsis(selectedCandidate.name, 30) || "N/A"}</p>
                    </div>
                    <Button
                      label="View Candidate"
                      disabled={
                        !(selectedCandidate.candidateId || selectedCandidate.id)
                      }
                      event={() =>
                        handleOpenCandidateDetails(
                          selectedCandidate.candidateId || selectedCandidate.id,
                        )
                      }
                      backgroundColor="#6860ee"
                      color="#FFFFFF"
                      style={{
                        padding: "4px 14px",
                        fontSize: "12px",
                        height: "28px",
                        borderRadius: "6px",
                        marginLeft: "10px",
                        flexShrink: 0,
                      }}
                    />
                  </div>
                  <div className="candidate-detail">
                    <div className="icon-with-header">
                      <img
                        src={emailIcon}
                        alt="emailIcon"
                        className="candidate-detail-icon"
                      />
                      <h4>Email</h4>
                    </div>
                    <p>{applyEllipsis(selectedCandidate.email, 30) || "N/A"}</p>
                  </div>
                  <div className="candidate-detail">
                    <div className="icon-with-header">
                      <img
                        src={contactNoIcon}
                        alt="contactIcon"
                        className="candidate-detail-icon"
                      />
                      <h4>Contact No.</h4>
                    </div>
                    <p>{selectedCandidate.contactNo || "N/A"}</p>
                  </div>
                  <div
                    className="candidate-detail"
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        minWidth: 0,
                        flex: 1,
                      }}
                    >
                      <div className="icon-with-header">
                        <img
                          src={jobIcon}
                          alt="jobIcon"
                          className="candidate-detail-icon"
                        />
                        <h4>Applied for</h4>
                      </div>
                      <p>
                        {applyEllipsis(
                          selectedCandidate.position,
                          windowWidth < 1570 ? 50 : 70,
                        )}
                      </p>
                    </div>
                    <Button
                      label="View Job"
                      disabled={
                        !(
                          selectedCandidate.jobId ||
                          selectedCandidate.jobData?.id
                        )
                      }
                      event={() =>
                        handleOpenJobsSideContainer(
                          selectedCandidate.jobId ||
                            selectedCandidate.jobData?.id,
                        )
                      }
                      backgroundColor="#6860ee"
                      color="#FFFFFF"
                      style={{
                        padding: "4px 14px",
                        fontSize: "12px",
                        height: "28px",
                        borderRadius: "6px",
                        marginLeft: "10px",
                        flexShrink: 0,
                      }}
                    />
                  </div>
                </div>
              </div>
              <div className="candidate-details-inner-container">
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                  }}
                >
                  <h3 className="schedule-header" style={{ margin: 0 }}>
                    Interview Details
                  </h3>
                  {isEditingInterview && (
                    <div
                      style={{
                        display: "inline-flex",
                        backgroundColor: "#c4c0fe40",
                        borderRadius: "8px",
                        padding: "4px",
                      }}
                    >
                      <Button
                        event={() => {
                          scheduleformik.setFieldValue(
                            "interviewType",
                            "online",
                          );
                          scheduleformik.setFieldValue("address1", "");
                          scheduleformik.setFieldValue("address2", "");
                          scheduleformik.setFieldValue("country", "");
                          scheduleformik.setFieldValue("state", "");
                          scheduleformik.setFieldValue("city", "");
                          scheduleformik.setFieldValue("zipcode", "");
                        }}
                        style={{
                          padding: "8px 20px",
                          border: "none",
                          borderRadius: "6px",
                          backgroundColor:
                            scheduleformik.values.interviewType === "online"
                              ? "#6860ee"
                              : "transparent",
                          color:
                            scheduleformik.values.interviewType === "online"
                              ? "white"
                              : "var(--header__color)",
                          fontWeight: "500",
                          fontSize: "14px",
                          cursor: "pointer",
                          display: "flex",
                          alignItems: "center",
                          gap: "8px",
                        }}
                      >
                        <VideoCallIcon fontSize="small" />
                        Online
                      </Button>
                      <Button
                        event={() => {
                          scheduleformik.setFieldValue(
                            "interviewType",
                            "offline",
                          );
                          scheduleformik.setFieldValue("meetingLink", "");
                        }}
                        style={{
                          padding: "8px 20px",
                          border: "none",
                          borderRadius: "6px",
                          backgroundColor:
                            scheduleformik.values.interviewType === "offline"
                              ? "#6860ee"
                              : "transparent",
                          color:
                            scheduleformik.values.interviewType === "offline"
                              ? "white"
                              : "var(--header__color)",
                          fontWeight: "500",
                          fontSize: "14px",
                          cursor: "pointer",
                          display: "flex",
                          alignItems: "center",
                          gap: "8px",
                        }}
                      >
                        <LocationOnIcon fontSize="small" />
                        In-Person
                      </Button>
                    </div>
                  )}
                </div>
                <div className="schedule-detail">
                  {!isEditingInterview && (
                    <div className="candidate-detail">
                      <div className="icon-with-header">
                        <img
                          src={interviewPersonIcon}
                          alt="interviewerIcon"
                          className="candidate-detail-icon"
                        />
                        <h4>
                          {isHiringTeamTenant ? "Coordinator" : "Interviewer"}
                        </h4>
                      </div>
                      <p>
                        {formatInterviewerName(
                          selectedCandidate.interviewPerson,
                        )}
                      </p>
                    </div>
                  )}
                </div>
                {isEditingInterview ? (
                  <>
                    <div
                      className="candidate-email-container"
                      style={{
                        display: "grid",
                        gridTemplateColumns: "180px 1fr",
                        gap: "15px",
                        alignItems: "center",
                        marginBottom: "15px",
                      }}
                    >
                      <div className="date-time-container">
                        <label className="interview-labels">
                          {isHiringTeamTenant ? "Coordinator" : "Interviewer"}{" "}
                          <span
                            style={{
                              whiteSpace: "nowrap",
                              display: "inline-flex",
                              alignItems: "center",
                              gap: "2px",
                            }}
                          >
                            {" "}
                            Name <span style={{ color: "red" }}>*</span>
                          </span>
                        </label>
                      </div>
                      <div style={{ marginLeft: "-65px" }}>
                        <Textfield
                          placeholder={
                            isHiringTeamTenant ? "Coordinator" : "Interviewer"
                          }
                          style={{ width: "100%" }}
                          name={"interviewPerson"}
                          value={scheduleformik.values.interviewPerson}
                          error={
                            scheduleformik.errors.interviewPerson &&
                            scheduleformik.touched.interviewPerson
                          }
                          errorMessage={scheduleformik.errors.interviewPerson}
                          onChange={scheduleformik.handleChange}
                          onBlur={scheduleformik.handleBlur}
                        />
                      </div>
                      <div className="date-time-container">
                        <label className="interview-labels">
                          Company{" "}
                          <span
                            style={{
                              whiteSpace: "nowrap",
                              display: "inline-flex",
                              alignItems: "center",
                              gap: "2px",
                            }}
                          >
                            {" "}
                            Name
                          </span>
                        </label>
                      </div>
                      {isHiringTeamTenant ? null : (
                        <div style={{ marginLeft: "-65px" }}>
                          <Textfield
                            placeholder={"Company Name"}
                            style={{ width: "100%" }}
                            name={"companyName"}
                            value={scheduleformik.values.companyName}
                            error={
                              scheduleformik.errors.companyName &&
                              scheduleformik.touched.companyName
                            }
                            errorMessage={scheduleformik.errors.companyName}
                            onChange={scheduleformik.handleChange}
                            onBlur={scheduleformik.handleBlur}
                          />
                        </div>
                      )}

                      <div className="date-time-container">
                        <label className="interview-labels">
                          Interview{" "}
                          <span
                            style={{
                              whiteSpace: "nowrap",
                              display: "inline-flex",
                              alignItems: "center",
                              gap: "2px",
                            }}
                          >
                            {" "}
                            Date <span style={{ color: "red" }}>*</span>
                          </span>
                        </label>
                      </div>
                      <div
                        className="time-and-error-container"
                        style={{ marginLeft: "-65px" }}
                      >
                        <div className="time-container">
                          <img
                            alt=""
                            src={isDarkMode ? darkCalendarIcon : calendarIcon}
                            className="calendarschedulerIcons"
                          />
                          <div
                            ref={rescheduleDateRef}
                            className="calendar-date-picker"
                            onClick={() => {
                              const rect =
                                rescheduleDateRef.current.getBoundingClientRect();
                              setPickerPosition({
                                top: rect.bottom + 6,
                                left: rect.left,
                              });
                              requestAnimationFrame(() => {
                                setActiveDatePicker("reschedule");
                                setIsDatePickerOpen(true);
                              });
                            }}
                          >
                            {scheduleformik.values.interviewDate
                              ? new Date(
                                  scheduleformik.values.interviewDate.getFullYear(),
                                  scheduleformik.values.interviewDate.getMonth(),
                                  scheduleformik.values.interviewDate.getDate(),
                                ).toLocaleDateString("en-US", {
                                  month: "long",
                                  day: "numeric",
                                  year: "numeric",
                                })
                              : "Select date"}
                          </div>
                        </div>
                        {scheduleformik.errors.interviewDate &&
                          scheduleformik.touched.interviewDate && (
                            <div className="time-error-message">
                              {scheduleformik.errors.interviewDate}
                            </div>
                          )}
                      </div>
                      <div className="date-time-container">
                        <label className="interview-labels">
                          Start{" "}
                          <span
                            style={{
                              whiteSpace: "nowrap",
                              display: "inline-flex",
                              alignItems: "center",
                              gap: "2px",
                            }}
                          >
                            {" "}
                            Time <span style={{ color: "red" }}>*</span>
                          </span>
                        </label>
                      </div>
                      <div
                        className="time-and-error-container"
                        style={{ marginLeft: "-65px" }}
                      >
                        <CustomTimePicker
                          selectedTime={scheduleformik.values.startTime}
                          onChange={(time) => {
                            scheduleformik.setFieldValue("startTime", time);
                            scheduleformik.setFieldTouched(
                              "startTime",
                              true,
                              false,
                            );
                            scheduleformik.validateField("startTime");
                          }}
                          placeholderText="Select start time"
                          style={{ width: "100%" }}
                        />
                        {/* <div className="time-container">
                        <img
                          alt=""
                          src={isDarkMode ? darkDashboardClock : dashboardClock}
                          className="calendarschedulerIcons"
                        />
     
                      </div> */}
                        {scheduleformik.errors.startTime &&
                          scheduleformik.touched.startTime && (
                            <div className="time-error-message">
                              {scheduleformik.errors.startTime}
                            </div>
                          )}
                      </div>
                      <div className="date-time-container">
                        <label className="interview-labels">
                          End{" "}
                          <span
                            style={{
                              whiteSpace: "nowrap",
                              display: "inline-flex",
                              alignItems: "center",
                              gap: "2px",
                            }}
                          >
                            {" "}
                            Time <span style={{ color: "red" }}>*</span>
                          </span>
                        </label>
                      </div>
                      <div
                        className="time-and-error-container"
                        style={{ marginLeft: "-65px" }}
                      >
                        <CustomTimePicker
                          selectedTime={scheduleformik.values.endTime}
                          onChange={(time) => {
                            scheduleformik.setFieldValue("endTime", time);
                            scheduleformik.setFieldTouched(
                              "endTime",
                              true,
                              false,
                            );
                            scheduleformik.validateField("endTime");
                          }}
                          placeholderText="Select end time"
                          style={{ width: "100%" }}
                        />
                        {/* <div className="time-container">
                        <img
                          alt=""
                          src={isDarkMode ? darkDashboardClock : dashboardClock}
                          className="calendarschedulerIcons"
                        />
             
                      </div> */}
                        {scheduleformik.errors.endTime &&
                          scheduleformik.touched.endTime && (
                            <div className="time-error-message">
                              {scheduleformik.errors.endTime}
                            </div>
                          )}
                      </div>
                    </div>
                    {isHiringTeamTenant ? (
                      <CandidateInterviewPanel
                        selectedIds={panelMemberIds}
                        onSelectionChange={setPanelMemberIds}
                      />
                    ) : null}
                    <Accordion
                      title={`Interview Meeting Details ${scheduleformik.values.interviewType === "online" ? "(Required)" : "(Not required for in-person interview)"}`}
                      titleColor="#6665ea"
                      accordionHeaderStyle={{
                        background: "var(--accordion-header-bg)",
                        color: "var(--header__color)",
                        padding: "12px 16px",
                        borderRadius: "8px",
                        marginBottom: "10px",
                        opacity:
                          scheduleformik.values.interviewType === "offline"
                            ? 0.6
                            : 1,
                      }}
                      defaultOpen={
                        scheduleformik.values.interviewType === "online"
                      }
                      isDisabled={
                        scheduleformik.values.interviewType === "offline"
                      }
                    >
                      <div style={{ padding: "0 10px 10px" }}>
                        <Textfield
                          label="Meeting Link"
                          name="meetingLink"
                          placeholder="Enter Your Meeting Link"
                          value={scheduleformik.values.meetingLink}
                          onChange={scheduleformik.handleChange}
                          onBlur={scheduleformik.handleBlur}
                          disabled={
                            scheduleformik.values.interviewType === "offline"
                          }
                          required={
                            scheduleformik.values.interviewType === "online"
                          }
                          error={
                            scheduleformik.errors.meetingLink &&
                            scheduleformik.touched.meetingLink
                          }
                          errorMessage={scheduleformik.errors.meetingLink}
                        />
                      </div>
                    </Accordion>
                    <Accordion
                      title={`Interview Location Details ${scheduleformik.values.interviewType === "offline" ? "(Required)" : "(Not required for online interview)"}`}
                      titleColor="#6665ea"
                      accordionHeaderStyle={{
                        background: "var(--accordion-header-bg)",
                        color: "var(--header__color)",
                        padding: "12px 16px",
                        borderRadius: "8px",
                        marginBottom: "10px",
                        opacity:
                          scheduleformik.values.interviewType === "online"
                            ? 0.6
                            : 1,
                      }}
                      defaultOpen={
                        scheduleformik.values.interviewType === "offline"
                      }
                      isDisabled={
                        scheduleformik.values.interviewType === "online"
                      }
                    >
                      <div style={{ padding: "0 10px 10px" }}>
                        <Textfield
                          label="Address Line 1"
                          name="address1"
                          placeholder="Address Line 1"
                          value={scheduleformik.values.address1}
                          onChange={scheduleformik.handleChange}
                          onBlur={scheduleformik.handleBlur}
                          disabled={
                            scheduleformik.values.interviewType === "online"
                          }
                          required={
                            scheduleformik.values.interviewType === "offline"
                          }
                          error={
                            scheduleformik.errors.address1 &&
                            scheduleformik.touched.address1
                          }
                          errorMessage={scheduleformik.errors.address1}
                        />
                        <Textfield
                          label="Address Line 2 (Optional)"
                          name="address2"
                          placeholder="Address Line 2"
                          value={scheduleformik.values.address2}
                          onChange={scheduleformik.handleChange}
                          disabled={
                            scheduleformik.values.interviewType === "online"
                          }
                        />
                        <div
                          style={{
                            display: "grid",
                            gridTemplateColumns: "1fr 1fr",
                            gap: "10px",
                          }}
                        >
                          <Textfield
                            label="Country"
                            name="country"
                            placeholder="Country"
                            value={scheduleformik.values.country}
                            onChange={scheduleformik.handleChange}
                            onBlur={scheduleformik.handleBlur}
                            disabled={
                              scheduleformik.values.interviewType === "online"
                            }
                            required={
                              scheduleformik.values.interviewType === "offline"
                            }
                            error={
                              scheduleformik.errors.country &&
                              scheduleformik.touched.country
                            }
                            errorMessage={scheduleformik.errors.country}
                          />
                          <Textfield
                            label="State"
                            name="state"
                            placeholder="State"
                            value={scheduleformik.values.state}
                            onChange={scheduleformik.handleChange}
                            onBlur={scheduleformik.handleBlur}
                            disabled={
                              scheduleformik.values.interviewType === "online"
                            }
                            required={
                              scheduleformik.values.interviewType === "offline"
                            }
                            error={
                              scheduleformik.errors.state &&
                              scheduleformik.touched.state
                            }
                            errorMessage={scheduleformik.errors.state}
                          />
                          <Textfield
                            label="City"
                            name="city"
                            placeholder="City"
                            value={scheduleformik.values.city}
                            onChange={scheduleformik.handleChange}
                            onBlur={scheduleformik.handleBlur}
                            disabled={
                              scheduleformik.values.interviewType === "online"
                            }
                            required={
                              scheduleformik.values.interviewType === "offline"
                            }
                            error={
                              scheduleformik.errors.city &&
                              scheduleformik.touched.city
                            }
                            errorMessage={scheduleformik.errors.city}
                          />
                          <Textfield
                            label="Zipcode"
                            type="number"
                            name="zipcode"
                            placeholder="Zipcode"
                            value={scheduleformik.values.zipcode}
                            onChange={scheduleformik.handleChange}
                            onBlur={scheduleformik.handleBlur}
                            disabled={
                              scheduleformik.values.interviewType === "online"
                            }
                            required={
                              scheduleformik.values.interviewType === "offline"
                            }
                            error={
                              scheduleformik.errors.zipcode &&
                              scheduleformik.touched.zipcode
                            }
                            errorMessage={scheduleformik.errors.zipcode}
                          />
                        </div>
                      </div>
                    </Accordion>
                  </>
                ) : (
                  <>
                    <div className="candidate-detail">
                      <div className="icon-with-header">
                        <img
                          src={dateIcon}
                          alt="dateIcon"
                          className="candidate-detail-icon"
                        />
                        <h4>When</h4>
                      </div>
                      <div className="date-and-time-container">
                        <span>{selectedCandidate.date}</span>
                        <span>{`${selectedCandidate.startTime} - ${selectedCandidate.endTime} (${selectedCandidate.timezone})`}</span>
                      </div>
                    </div>

                    <div className="candidate-detail">
                      <div className="icon-with-header">
                        <img
                          src={dateIcon}
                          alt="linkIcon"
                          className="candidate-detail-icon"
                        />
                        <h4>Interview Type</h4>
                      </div>
                      <p style={{ textTransform: "capitalize" }}>
                        {selectedCandidate.interviewType}
                      </p>
                    </div>

                    {selectedCandidate.meetingLink &&
                      selectedCandidate.interviewType === "online" && (
                        <div className="candidate-detail">
                          <div className="icon-with-header">
                            <img
                              src={linkIcon}
                              alt="linkIcon"
                              className="candidate-detail-icon"
                            />
                            <h4>Meeting Link</h4>
                          </div>
                          <div className="meeting-link-scroll-container">
                            <a
                              href={selectedCandidate.meetingLink}
                              target="_blank"
                              rel="noopener noreferrer"
                              className="detail-value link"
                            >
                              {selectedCandidate.meetingLink}
                            </a>
                          </div>
                        </div>
                      )}

                    {selectedCandidate.interviewType === "offline" &&
                      selectedCandidate.address1 && (
                        <div className="candidate-detail">
                          <div className="icon-with-header">
                            <LocationOnIcon
                              className="candidate-detail-icon"
                              style={{
                                color: "var(--header__color)",
                                opacity: 0.8,
                              }}
                            />
                            <h4>Location</h4>
                          </div>
                          <p>
                            {selectedCandidate.address1}
                            {selectedCandidate.address2 &&
                              `, ${selectedCandidate.address2}`}
                            {selectedCandidate.city &&
                              `, ${selectedCandidate.city}`}
                            {selectedCandidate.state &&
                              `, ${selectedCandidate.state}`}
                            {selectedCandidate.country &&
                              `, ${selectedCandidate.country}`}
                            {selectedCandidate.zipcode &&
                              ` ${selectedCandidate.zipcode}`}
                          </p>
                        </div>
                      )}
                  </>
                )}
              </div>
              {!isEditingInterview && storePanelData.length > 0 && (
                <div
                  style={{
                    marginTop: "8px",
                    background:
                      "var(--sidepopup-content-background, transparent)",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                      gap: "12px",
                      flexWrap: "wrap",
                      marginBottom: "18px",
                    }}
                  >
                    <h3
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "10px",
                        margin: 0,
                        color: "#7167f8",
                        fontSize: "16px",
                        fontWeight: 500,
                      }}
                    >
                      Interview Panel &amp; Evaluators (2)
                    </h3>
                    <span style={{ color: "#858592", fontSize: "14px" }}>
                      Assigned Evaluators
                    </span>
                  </div>

                  {storePanelData.map((evaluator) => (
                    <div
                      key={evaluator.user_name}
                      style={{
                        border: "1px solid var(--border__color, #e7e8ef)",
                        borderRadius: "20px",
                        padding: "20px 24px 16px",
                        marginBottom: "16px",
                        background:
                          "var(--sidepopup-card-background, transparent)",
                      }}
                    >
                      <div
                        style={{
                          display: "flex",
                          alignItems: "flex-start",
                          justifyContent: "space-between",
                          gap: "14px",
                        }}
                      >
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "20px",
                            minWidth: 0,
                          }}
                        >
                          <div
                            style={{
                              width: "40px",
                              height: "40px",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              borderRadius: "50%",
                              border: "2px solid #d4d9ff",
                              background: "#f0efff",
                              color: "#7469ed",
                              fontSize: "20px",
                              fontWeight: 500,
                            }}
                          >
                            {evaluator.first_name.slice(0, 2)}
                          </div>
                          <div style={{ minWidth: 0 }}>
                            <div
                              style={{
                                color: "var(--header__color)",
                                fontSize: "16px",
                                fontWeight: 500,
                                marginBottom: "6px",
                              }}
                            >
                              {evaluator.first_name} {evaluator.last_name}
                            </div>
                          </div>
                        </div>
                      </div>

                      <div
                        style={{
                          borderTop: "1px solid var(--border__color, #ececf2)",
                          marginTop: "18px",
                          paddingTop: "14px",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "space-between",
                          gap: "16px",
                        }}
                      >
                        <div style={{ minWidth: 0, flex: 1 }}>
                          {evaluator.rating ? (
                            <>
                              <div
                                style={{
                                  display: "flex",
                                  justifyContent: "space-between",
                                }}
                              >
                                <div>
                                  <div
                                    aria-label={`Evaluation score ${evaluator.score} out of 5`}
                                    style={{
                                      display: "flex",
                                      gap: "2px",
                                      color: "#ff9800",
                                      fontSize: "22px",
                                      lineHeight: 1.1,
                                      letterSpacing: "-1px",
                                      marginBottom: "7px",
                                      alignItems: "center",
                                      flexWrap: "wrap",
                                    }}
                                  >
                                    {Array.from({ length: 5 }, (_, index) => (
                                      <span
                                        key={index}
                                        style={{
                                          color:
                                            index < evaluator.rating
                                              ? "#ff9800"
                                              : "#e6e7ef",
                                        }}
                                      >
                                        ★
                                      </span>
                                    ))}
                                    {evaluator.hiring_recommendation && (() => {
                                      const recommendation = String(
                                        evaluator.hiring_recommendation,
                                      ).trim();
                                      const normalizedRecommendation =
                                        recommendation.toLowerCase();
                                      const recommendationColors = {
                                        "strong hire": {
                                          background: "#dcfce7",
                                          color: "#166534",
                                        },
                                        hire: {
                                          background: "#fef3c7",
                                          color: "#92400e",
                                        },
                                        hold: {
                                          background: "#ffedd5",
                                          color: "#c2410c",
                                        },
                                        "no hire": {
                                          background: "#fee2e2",
                                          color: "#b91c1c",
                                        },
                                      };
                                      const pillColors =
                                        recommendationColors[
                                          normalizedRecommendation
                                        ] || {
                                          background: "#e5e7eb",
                                          color: "#374151",
                                        };
                                      return (
                                        <span
                                          style={{
                                            display: "inline-flex",
                                            alignItems: "center",
                                            padding: "4px 10px",
                                            borderRadius: "999px",
                                            background: pillColors.background,
                                            color: pillColors.color,
                                            fontSize: "12px",
                                            lineHeight: 1.2,
                                            fontWeight: 600,
                                            letterSpacing: 0,
                                            marginLeft: "8px",
                                          }}
                                        >
                                          {recommendation}
                                        </span>
                                      );
                                    })()}
                                  </div>
                                  {evaluator?.notes && (
                                    <p
                                      style={{
                                        margin: 0,
                                        color: "#858592",
                                        fontSize: "14px",
                                        fontStyle: "italic",
                                        lineHeight: 1.5,
                                        overflowWrap: "anywhere",
                                      }}
                                    >
                                      "{evaluator.notes}"
                                    </p>
                                  )}
                                </div>
                                {isHiringTeamTenant &&
                                  userDetails?.id != null &&
                                  String(evaluator.user_id) ===
                                    String(userDetails.id) && (
                                    <Button
                                      label="Edit Feedback"
                                      event={() => {
                                        setFeedbackMember(evaluator);
                                        setIsFeedbackPopupOpen(true);
                                      }}
                                    />
                                  )}
                              </div>
                            </>
                          ) : (
                            <div
                              style={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "space-between",
                                gap: "12px",
                              }}
                            >
                              <span
                                style={{
                                  color: "#858592",
                                  fontSize: "14px",
                                  fontStyle: "italic",
                                }}
                              >
                                Feedback pending evaluation
                              </span>
                              {isHiringTeamTenant &&
                                userDetails?.id != null &&
                                String(evaluator.user_id) ===
                                  String(userDetails.id) && (
                                  <Button
                                    label="Add Feedback"
                                    event={() => {
                                      setFeedbackMember(evaluator);
                                      setIsFeedbackPopupOpen(true);
                                    }}
                                  />
                                )}
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              )}

              <div className="schedule-button-container">
                {isEditingInterview ? (
                  <>
                    <Button
                      label="Back"
                      isCancel={true}
                      event={handleBackClick}
                      style={{
                        padding: "22px",
                        height: "40px",
                        borderRadius: "8px",
                        margin: 0,
                      }}
                    />
                    <CustomTooltip
                      title={
                        canAccessPreview()
                          ? "Click to view preview"
                          : "Fill all required fields to view preview"
                      }
                      arrow
                    >
                      <span>
                        <Button
                          label={
                            previewData.isLoading
                              ? "Loading..."
                              : "Email Preview"
                          }
                          event={fetchEmailPreview}
                          backgroundColor="#6860ee"
                          color="#FFFFFF"
                          disabled={
                            !canAccessPreview() || previewData.isLoading
                          }
                          style={{ padding: "13px" }}
                          {...((!canAccessPreview() ||
                            previewData.isLoading) && {
                            hoverd: false,
                            hoverStyles: {},
                            hoverIconSrc: null,
                            style: {
                              backgroundColor: "var(--disabled-button)",
                              color: "white",
                              cursor: "not-allowed",
                              opacity: 0.7,
                              padding: "14px",
                            },
                          })}
                        />
                      </span>
                    </CustomTooltip>
                    <Button
                      label={
                        isSubmittingUpdate ? "Updating..." : "Update Interview"
                      }
                      backgroundColor="#6860ee"
                      color="white"
                      iconSrc={rescheduleIcon}
                      style={{
                        padding: "10px 20px",
                        borderRadius: "8px",
                        boxShadow: "0 4px 12px rgba(104, 96, 238, 0.2)",
                        border: "none",
                        fontWeight: "500",
                        marginRight: "0",
                      }}
                      event={handleUpdateInterview}
                    />
                  </>
                ) : (
                  <>
                    <CustomTooltip
                      title={getMonthlyEmailTooltip(
                        "Update and send the interview details to this candidate.",
                      )}
                      arrow
                    >
                      <Button
                        label={"Reschedule Interview"}
                        backgroundColor="#6860ee"
                        color="white"
                        iconSrc={rescheduleIcon}
                        style={{
                          padding: "10px 20px",
                          borderRadius: "8px",
                          boxShadow: "0 4px 12px rgba(104, 96, 238, 0.2)",
                          border: "none",
                          fontWeight: "500",
                          opacity: isMonthlyEmailLimitReached ? 0.6 : 1,
                        }}
                        disabled={isMonthlyEmailLimitReached}
                        event={handleRescheduleClick}
                      />
                    </CustomTooltip>
                    <Button
                      label="Cancel Interview"
                      isCancel={true}
                      iconSrc={cancelScheduleIcon}
                      style={{
                        padding: "10px 20px",
                        borderRadius: "8px",
                        fontWeight: "500",
                        margin: 0,
                      }}
                      event={() =>
                        handleOpenDeleteModal(
                          events.find(
                            (e) => e.candidateName === selectedCandidate.name,
                          ),
                        )
                      }
                    />
                  </>
                )}
              </div>
            </div>
          </div>
        )}
      </SidePopup>

      {isCandidateModalOpen && viewingCandidate && (
        <SidePopup
          key={viewingCandidate?.id || "candidate-details"}
          isOpen={isCandidateModalOpen}
          onClose={handleCloseCandidateModal}
          title="Candidate Details"
          showDeleteButton={false}
          sidePopupWidth={"80%"}
          headerBackgroundColor="var(--sidepopup-header-background)"
          titleColor="var(--sidepopup-header-color)"
        >
          <CandidateDetailsContainer
            candidate={viewingCandidate}
            activeTab={candidateActiveTab}
            setActiveTab={setCandidateActiveTab}
            handleTabChange={(index) => setCandidateActiveTab(index)}
            hasSearched={false}
            showCandidateRecommendedJobsTab={false}
            hideSearchBox={true}
            assignedVendor={assignedVendor}
          />
        </SidePopup>
      )}

      {selectedJob && (
        <JobsDetailsContainer
          isOpen={jobsSideContainerOpen}
          onClose={handleCloseJobsSideContainer}
          selectedJob={selectedJob}
          jobId={selectedJob?.id}
          activeTab={jobActiveTab}
          setActiveTab={setJobActiveTab}
          showJobDetailsTab={true}
          showAssignedCandidatesTab={true}
          showRecommendedCandidatesTab={false}
          showDocumentsTab={true}
          hideSearchBox={true}
          isEditable={false}
          assignedCount={assignedCount}
          setAssignedCount={setAssignedCount}
          onAssignedCountChange={setAssignedCount}
        />
      )}

      {ReactDOM.createPortal(
        <StandardPopup
          isOpen={isFeedbackPopupOpen}
          onClose={() => {
            setIsFeedbackPopupOpen(false);
            feedbackFormik.resetForm();
          }}
          title={feedbackMember?.rating ? "Edit Interviewer Feedback" : "Add Interviewer Feedback"}
          hideActions={true}
          width="640px"
          maxHeight="90vh"
          popupStyle={{
            borderRadius: "24px",
            padding: 0,
            overflow: "hidden",
          }}
          contentStyle={{
            padding: 0,
            marginTop: 0,
          }}
        >
          <form
            onSubmit={feedbackFormik.handleSubmit}
            style={{
              boxSizing: "border-box",
              padding: "0 34px 32px",
              color: "var(--header__color)",
            }}
          >
            <section style={{ marginBottom: "30px" }}>
              <label
                style={{
                  display: "block",
                  marginBottom: "10px",
                  marginTop: "30px",
                  color: "var(--header__color)",
                  fontSize: "16px",
                  fontWeight: 500,
                }}
              >
                Evaluation Score ({feedbackFormik.values.score} to 5 Stars)
              </label>
              <div
                style={{ display: "flex", alignItems: "center", gap: "26px" }}
              >
                <div
                  role="group"
                  aria-label="Evaluation score"
                  style={{ display: "flex", alignItems: "center", gap: "14px" }}
                >
                  {[1, 2, 3, 4, 5].map((star) => {
                    const isSelected =
                      star <=
                      (hoveredFeedbackScore || feedbackFormik.values.score);
                    return (
                      <button
                        type="button"
                        key={star}
                        aria-label={`${star} ${star === 1 ? "star" : "stars"}`}
                        aria-pressed={feedbackFormik.values.score === star}
                        onMouseEnter={() => setHoveredFeedbackScore(star)}
                        onMouseLeave={() => setHoveredFeedbackScore(0)}
                        onFocus={() => setHoveredFeedbackScore(star)}
                        onBlur={() => setHoveredFeedbackScore(0)}
                        onClick={() =>
                          feedbackFormik.setFieldValue("score", star)
                        }
                        style={{
                          display: "inline-flex",
                          alignItems: "center",
                          justifyContent: "center",
                          width: "38px",
                          height: "38px",
                          padding: 0,
                          border: 0,
                          background: "transparent",
                          cursor: "pointer",
                        }}
                      >
                        <img
                          src={
                            isSelected ? SelectedStarIcon : NotSelectedStarIcon
                          }
                          alt=""
                          style={{ width: "29px", height: "29px" }}
                        />
                      </button>
                    );
                  })}
                </div>
                <span
                  style={{
                    whiteSpace: "nowrap",
                    color: "var(--header__color)",
                    fontSize: "16px",
                  }}
                >
                  {feedbackFormik.values.score} / 5
                </span>
              </div>
            </section>

            <section style={{ marginBottom: "24px" }}>
              <label
                style={{
                  display: "block",
                  marginBottom: "10px",
                  color: "var(--header__color)",
                  fontSize: "16px",
                  fontWeight: 500,
                }}
              >
                Recommendation
              </label>
              <MonthFilter
                value={feedbackFormik.values.hiringRecommendation}
                onChange={(value) =>
                  feedbackFormik.setFieldValue("hiringRecommendation", value)
                }
                options={[
                  { label: "Strong Hire", value: "Strong Hire" },
                  { label: "Hire", value: "Hire" },
                  { label: "Hold", value: "Hold" },
                  { label: "No Hire", value: "No Hire" },
                ]}
                ariaLabel="Hiring recommendation"
              />
            </section>

            <div>
              <TextArea
                name="feedbackNotes"
                label="Feedback Notes & Technical Justification"
                placeholder="Candidate demonstrated deep technical competence, handled edge cases well..."
                value={feedbackFormik.values.feedbackNotes}
                onChange={feedbackFormik.handleChange}
                onBlur={feedbackFormik.handleBlur}
                rows={4}
                containerClassName="input-field"
                containerStyle={{ width: "100%" }}
                style={{
                  height: "100px",
                  border: "1px solid var(--border__color)",
                  borderRadius: "12px",
                  padding: "16px",
                  boxSizing: "border-box",
                  fontFamily: "inherit",
                  fontSize: "15px",
                  lineHeight: 1.5,
                }}
              />
            </div>

            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "flex-end",
                gap: "12px",
                marginTop: "36px",
              }}
            >
              <button
                type="button"
                onClick={() => {
                  setIsFeedbackPopupOpen(false);
                  setFeedbackMember(null);
                }}
                style={{
                  minHeight: "46px",
                  padding: "0 18px",
                  border: "1px solid var(--border__color)",
                  borderRadius: "14px",
                  background: "transparent",
                  color: "var(--header__color)",
                  fontFamily: "inherit",
                  fontSize: "15px",
                  fontWeight: 500,
                  cursor: "pointer",
                }}
              >
                Cancel
              </button>
              <button
                type="submit"
                style={{
                  minHeight: "46px",
                  padding: "0 18px",
                  border: "1px solid #6956e8",
                  borderRadius: "14px",
                  background: "#6956e8",
                  color: "#fff",
                  fontFamily: "inherit",
                  fontSize: "15px",
                  fontWeight: 500,
                  cursor: "pointer",
                }}
              >
                {feedbackMember?.rating ? "Update Feedback" : "Save Feedback"}
              </button>
            </div>
          </form>
        </StandardPopup>,
        document.body,
      )}

      {isDatePickerOpen && pickerPosition.top !== null && (
        <CustomDatePickerModal
          initialDate={
            activeDatePicker === "reschedule"
              ? scheduleformik.values.interviewDate || selectedDate
              : selectedDate
          }
          currentView={
            activeDatePicker === "reschedule" ? Views.DAY : currentView
          }
          onOk={(date) => {
            if (activeDatePicker === "reschedule") {
              scheduleformik.setFieldValue("interviewDate", date);
            } else {
              setSelectedDate(date);
            }
            setIsDatePickerOpen(false);
            setActiveDatePicker(null);
            setPickerPosition({ top: null, left: null });
          }}
          onClose={() => {
            setIsDatePickerOpen(false);
            if (activeDatePicker === "reschedule") {
              scheduleformik.setFieldTouched("interviewDate", true);
            }
            setActiveDatePicker(null);
            setPickerPosition({ top: null, left: null });
          }}
          top={pickerPosition.top}
          left={pickerPosition.left}
        />
      )}

      <ContentDialog
        isOpen={showDeleteModal}
        title="Delete Interview"
        onClose={handleCloseDeleteModal}
        submitButtonLabel="Delete"
        cancelButtonLabel="Cancel"
        event={handleDeleteEvent}
        showCloseIcon={false}
        contentHeight="auto"
        contentWidth="30%"
      >
        <div
          style={{
            padding: "15px 0",
            textAlign: "center",
          }}
        >
          <div
            style={{
              width: "60px",
              height: "60px",
              borderRadius: "50%",
              background: "rgba(255, 82, 82, 0.1)",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              margin: "0 auto 20px",
            }}
          >
            <img
              src={cancelScheduleIcon}
              alt="Cancel"
              style={{
                width: "30px",
                height: "30px",
                opacity: 0.8,
              }}
            />
          </div>
          <p
            style={{
              fontSize: "16px",
              lineHeight: "1.5",
              color: "var(--header__color)",
            }}
          >
            Are you sure you want to delete this interview with
            <span
              style={{
                fontWeight: "600",
                color: "#6860ee",
                margin: "0 5px",
              }}
            >
              {selectedCandidate?.name}
            </span>
            ?
          </p>
          <p
            style={{
              fontSize: "14px",
              color: "#999",
              marginTop: "10px",
            }}
          >
            This action cannot be undone.
          </p>
        </div>
      </ContentDialog>
      {ReactDOM.createPortal(
        <StandardPopup
          isOpen={isEmailPreviewOpen}
          onClose={() => setIsEmailPreviewOpen(false)}
          title="Email Preview"
          hideActions={true}
          width="900px"
          maxHeight="95vh"
          popupStyle={{
            overflow: "hidden",
            display: "flex",
            flexDirection: "column",
          }}
          contentStyle={{
            padding: 0,
            marginTop: 0,
          }}
        >
          <div style={{ overflow: "hidden" }}>
            <EmailPreviewPopup htmlContent={previewData.body} />
          </div>
        </StandardPopup>,
        document.body,
      )}
    </div>
  );
};

export default MyCalendar;